<template>
	<!-- ======================= -->
	<div>
		<div class="s-head-bg">
			<div class="s-head-box">
				<div class="s-head-l">
					<img src="../assets/images/logo.png" />
				</div>
				<div class="s-head-r">
					<div class="head-snav-ul">
						<div class="head-snav-li" v-for="(item,index) in snavList" :key="index">
							<div :class="['headCell',item.isSelect]" @click="tabClick(index)" @mouseenter="handleMouseOver(index)">
								<font>{{item.name}}</font>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- <div class="h-tab-box" v-show="brandIf" @mouseleave="outMouseOver">
				<div class="h-tab-ul">
					<div class="h-tab-li" v-for="(item,index) in tabList" :key="index">
						<div :class="['h-tab-cell',item.isSet]" @mouseenter="tabMouseOver(index)" @click="gotoBrand(index)">
							<img :src="item.url" />
							<div class="h-tab-line"></div>
						</div>
					</div>
				</div>
			</div> --> 
			<div class="h-tab-box" v-show="tabIf" @mouseleave="outMouseOver">
				<div class="h-tab-ul">
					<div class="h-tab-li" v-for="(item,index) in tabList" :key="index">
						<div :class="['h-tab-cell',item.isSet]" @mouseenter="tabMouseOver(index)">
							<img :src="item.url" />
							<div class="h-tab-line"></div>
						</div>
					</div>
				</div>
				<div class="h-snav-box" v-show="tabIndex==0">
					<div class="h-snav-ul">
						<div class="h-snav-li" v-for="(item,index) in skldList" :key="index">
							<div :class="['h-snav-cell',item.isSet]" @mouseenter="skldMouseOver(index)" @click="gotoClick(index)">
								<font class="h-snav-pont">·</font>
								<font>{{item.name}}</font>
							</div>
							
						</div>
					</div>
					<!-- <div class="h-snav-ul">
						<div class="h-snav-li" v-for="(item,index) in typeList" :key="index">
							<div :class="['h-snav-cell',item.isSet]" @mouseenter="typeMouseOver(index)">
								<font class="h-snav-pont">·</font>
								<font>{{item.name}}</font>
							</div>
							
						</div>
					</div>
					<div class="h-snav-ul">
						<div class="h-snav-li" v-for="(item,index) in productList" :key="index">
							<div :class="['h-snav-cell',item.isSet]" @mouseenter="productMouseOver(index)" @click="gotoClick(index)">
								<font class="h-snav-pont">·</font>
								<font>{{item.name}}</font>
							</div>
							
						</div>
					</div> -->
				</div>
				<!-- ============================= -->
				<div class="h-snav-box energyText" v-show="tabIndex==1">
					<div class="h-snav-ul">
						<div class="h-snav-li" v-for="(item,index) in energyList" :key="index">
							<div :class="['h-snav-cell',item.isSet]" @mouseenter="energyMouseOver(index)" @click="gotoClick(index)">
								<font class="h-snav-pont">·</font>
								<font>{{item.name}}</font>
							</div>
							
						</div>
					</div>
				</div>
				<!-- ============================= -->
				<div class="h-snav-box lightText" v-show="tabIndex==2">
					<div class="h-snav-ul">
						<div class="h-snav-li" v-for="(item,index) in lightList" :key="index">
							<div :class="['h-snav-cell',item.isSet]" @mouseenter="lightMouseOver(index)" @click="gotoClick(index)">
								<font class="h-snav-pont">·</font>
								<font>{{item.name}}</font>
							</div>
							
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="s-head-height"></div>
	</div>
	
	
</template>

<script>
	export default {
		data() {
			return {
				brandIf:false,
				snavList:[
					{id:1,isSelect:'select',name:'首页',url:'/'},
					// {id:2,isSelect:'',name:'品牌',url:'/brand'},
					{id:7,isSelect:'',name:'AI大模型',url:'/AI'},
					{id:3,isSelect:'',name:'产品介绍',url:''},
					{id:4,isSelect:'',name:'服务支持',url:'/service'},
					{id:5,isSelect:'',name:'新闻中心',url:'/news'},
					{id:6,isSelect:'',name:'联系我们',url:'/contact'},
				],
				tabIf:false,
				tabList:[
					{id:1,isSet:'select',url:require(`@/assets/images/head/logo1.png`)},
					// {id:2,isSet:'',url:require(`@/assets/images/head/logo2.png`)},
					{id:3,isSet:'',url:require(`@/assets/images/head/logo3.png`)},
				],//项目列表
				tabIndex:0,
				typeList:[],//产品类型列表
				typeIndex:0,
				slowList:[
					{id:1,isSet:'select',name:'壁挂式'},
					{id:2,isSet:'',name:'立柱式'},
					{id:3,isSet:'',name:'移动式'},
					{id:4,isSet:'',name:'一体机'},
				],
				productList:[],//选中产品列表
				productIndex:0,
				p1List:[
					{id:1,isSet:'',name:'闪开来电10路壁挂式V3充电机(2200W)',url:''},
					{id:6,isSet:'',name:'闪开来电10路壁挂式V4充电机',url:''},
				],
				p2List:[
					{id:2,isSet:'',name:'闪开来电2路立柱式S2充电桩',url:''},
					{id:3,isSet:'',name:'闪开来电4路立柱式天幕充电桩',url:''},
					{id:7,isSet:'',name:'闪开来电10路立柱式s2充电桩',url:''},
				],
				p3List:[
					{id:4,isSet:'',name:'闪开来电2路移动式M2智能插座(4G版)',url:''},
				],
				p4List:[
					{id:5,isSet:'',name:'闪开来电10路一体化充电机',url:''},
				],
				// 闪开来电产品
				skldList: [
					{id:1,isSet:'select',name:'闪开来电10路立柱式天幕充电桩',url:''},
					{id:2,isSet:'',name:'闪开来电10路壁挂式V4充电机',url:''},
					{id:3,isSet:'',name:'闪开来电10路立柱式S2充电桩',url:''},
					{id:4,isSet:'',name:'闪开来电10路一体化充电机',url:''},
					{id:5,isSet:'',name:'闪开来电2路移动式M2智能插座（4G版）',url:''},
				],
				// ====闪开新能源======
				// energyList:[
				// 	{id:1,isSet:'select',name:'闪开新恒7kw交流充电桩',url:''},
				// 	{id:6,isSet:'',name:'闪开新越7kw交流充电桩',url:''},
				// 	{id:7,isSet:'',name:'闪开新越14kw双枪交流充电桩',url:''},
				// 	{id:8,isSet:'',name:'闪开新耀14kw双枪交流充电桩',url:''},
				// 	{id:2,isSet:'',name:'闪开20kw单枪直流充电桩',url:''},
				// 	{id:3,isSet:'',name:'闪开30/40kw单枪直流充电桩',url:''},
				// 	{id:4,isSet:'',name:'闪开双枪直流充电桩',url:''},
				// 	{id:5,isSet:'',name:'闪开智能车位地锁',url:''},
				// ],
				energyList:[
					{id:1,isSet:'select',name:'解决方案',url:''},
					{id:6,isSet:'',name:'桩灯结合',url:''},
				],
				// ==闪开光合====
				lightList:[
					{id:1,isSet:'select',name:'超节能常亮灯管',url:''},
					{id:2,isSet:'',name:'物联网灯管',url:''},
				]
			}
		},
		//初始化执行
		mounted() {//此处代替onLoad
			var self = this
			self.pageLoad()
		},
		onShow() {
			var self = this
		},
		methods: {
			pageLoad(){
				var self = this
				const index = localStorage.getItem('headSelectIndex')
				if(index){
					self.tabClick(index)
				}else{
					self.tabClick(0)
				}
				self.onCheck()
			},
			//初始选中
			onCheck(){
				var self = this
				self.tabIndex = 0
				self.tabIndex = 0
				self.typeIndex = 0
				self.productIndex = 0
				self.typeList = self.slowList
				self.productList = self.p1List
				self.tabMouseOver(0)
				self.typeMouseOver(0)
				self.productMouseOver(0)
			},
			//点击切换跳转
			tabClick(index){
				var self = this
				for(var i in self.snavList){
					if(self.snavList[i].isSelect){
						self.snavList[i].isSelect = ''
					}					
				}
				localStorage.setItem('headSelectIndex', index)
				var obj = self.snavList[index]
				obj.isSelect = 'select'
				if(index==2){
					return
				}
				this.$router.push(obj.url)
			},
			//鼠标离开
			handleMouseOut(){
				var self = this
				self.brandIf = false
				self.tabIf = false
			},
			//鼠标经过
			handleMouseOver(index){
				var self = this
				self.changeSelect(index);
				if(index==2){
					self.onCheck()
					self.brandIf = false
					self.tabIf = true
				}else if(index==1){
					self.brandIf = true
					self.tabIf = false
				}else{
					self.brandIf = false
					self.tabIf = false
				}
			},
			//鼠標离开隐藏tab切换
			outMouseOver(){
				var self = this
				self.brandIf = false
				self.tabIf = false
			},
			//鼠标经过切换选中
			changeSelect(index){
				var self = this
				for(var i in self.snavList){
					if(self.snavList[i].isSelect){
						self.snavList[i].isSelect = ''
					}					
				}
				var obj = self.snavList[index]
				obj.isSelect = 'select'
			},
			gotoBrand(index){
				var self = this
				if(index==0){
					this.$router.push({ path: '/brands'})
				}else if(index==1){
					this.$router.push({ path: '/brand'})
				}else if(index==2){
					this.$router.push({ path: '/product', query: { tabId: 2,productId:0} })
				}
				self.brandIf = false
			},
			//产品tab切换
			tabMouseOver(index){
				var self = this
				for(var i in self.tabList){
					if(self.tabList[i].isSet){
						self.tabList[i].isSet = ''
					}					
				}
				var obj = self.tabList[index]
				obj.isSet = 'select'
				self.tabIndex = index
			},
			//产品类型切换
			typeMouseOver(index){
				var self = this
				for(var i in self.typeList){
					if(self.typeList[i].isSet){
						self.typeList[i].isSet = ''
					}					
				}
				var obj = self.typeList[index]
				obj.isSet = 'select'
				self.typeIndex = index
				if(index==0){
					self.productList = self.p1List
				}else if(index==1){
					self.productList = self.p2List
				}else if(index==2){
					self.productList = self.p3List
				}else if(index==3){
					self.productList = self.p4List
				}
			},
			//产品选择
			productMouseOver(index){
				var self = this
				for(var i in self.productList){
					if(self.productList[i].isSet){
						self.productList[i].isSet = ''
					}					
				}
				var obj = self.productList[index]
				obj.isSet = 'select'
				self.productIndex = index
			},
			skldMouseOver(index){
				var self = this
				for(var i in self.skldList){
					if(self.skldList[i].isSet){
						self.skldList[i].isSet = ''
					}					
				}
				var obj = self.skldList[index]
				obj.isSet = 'select'
			},
			//闪开新能源产品列表切换
			energyMouseOver(index){
				var self = this
				for(var i in self.energyList){
					if(self.energyList[i].isSet){
						self.energyList[i].isSet = ''
					}					
				}
				var obj = self.energyList[index]
				obj.isSet = 'select'
			},
			//闪开光合产品切换
			lightMouseOver(index){
				var self = this
				for(var i in self.lightList){
					if(self.lightList[i].isSet){
						self.lightList[i].isSet = ''
					}					
				}
				var obj = self.lightList[index]
				obj.isSet = 'select'
			},
			//跳转页面
			gotoClick(index){
				var self = this
				var obj = {}
				var productId = index
				if(self.tabIndex==0){
					obj = self.skldList[index]
					productId = obj.id
				}else if(self.tabIndex==1){
					obj = self.energyList[index]
				}else if(self.tabIndex==2){
					obj = self.lightList[index]
				}
				localStorage.setItem('headSelectIndex', 2)
				self.snavList[2].isSelect = 'select'
				self.tabIf = false
				const id = self.tabIndex
				this.$router.push({ path: '/product', query: { tabId: id,productId:productId} })
				self.onCheck()
			}
		}
	}
</script>

<style>
	/* ================ */
	.s-head-bg{
		width: 100%;
		overflow: hidden;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 99;
	}	
	/* ========================= */
	@media screen and (max-width:750px) {
		.s-head-height{
			height: 1rem;
		}
		.s-head-box{
			width: 100%;
			padding-top: .5rem;
			background-color: #fff;
		}
		.s-head-l{
			width: 40%;
			margin: 0 auto;
		}
		.s-head-r{
			width: 100%;
			margin: 0 auto;
		}
		.head-snav-ul{
			padding: 0 .5rem;
			padding-right: 2%;
			display: flex;
			justify-content: space-between;
		}
		.headCell{
			padding: .5rem 0;
			font-size: .8rem;
			cursor: pointer;
		}
		.head-snav-li .select{
			color: #88AF51;
		}
		/* ============================ */
		.h-tab-box{
			padding: 30px 2%;
		}
		.h-tab-ul{
			display: flex;
			justify-content: start;
			align-items: center;
		}
		.h-tab-li{
			width: 32%;
		}
		.h-tab-cell{
			width: 70%;
			margin: 0 auto;
			padding-bottom: 1rem;
			cursor: pointer;
			position: relative;
		}
		.h-tab-line{
			width: 100%;
			height: .5rem;
			background-color: #a0cc5e;
			border-radius: .2rem;
			opacity: 0;
			position: absolute;
			bottom: -.1rem;
			left: 0;
		}
		.h-tab-cell.select .h-tab-line{
			opacity: 1;
		}
		/* =================== */
		.h-snav-box{
			margin-top: .5rem;
			display: flex;
			margin-left: 9%;
		}
		.h-snav-ul{
			margin-right: 2%;
		}
		.h-snav-cell{
			padding-top: .8rem;
			display: flex;
			justify-content: flex-start;
			align-items: center;
			font-weight: bold;
			color: black;
			cursor: pointer;
		}
		.h-snav-cell font{
			font-size: .8rem !important;
		}
		.h-snav-pont{
			margin-right: .4rem;
			font-size: 1.5rem;
		}
		.h-snav-cell.select{
			color: #a0cc5e;
		}
		.h-snav-box.energyText{
			justify-content: flex-end;
			margin-left: 41%;
		}
		.h-snav-box.lightText{
			justify-content:flex-end;
		}
		.lightText .h-snav-ul{
			width: 28%;
		}
	}
	/* ===PC上=== */
	@media screen and (min-width:755px) {
		.s-head-box{
			padding: 0 10%;
			background-color: #fff;
			display: flex;
			justify-content: space-between;
			align-items: center;
		}
		.s-head-l{
			width: 13%;
		}
		.head-snav-ul{
			display: flex;
			justify-content: center;
		}
		.headCell{
			padding: 1.5vw 1vw;
			font-size: .89vw;
			font-weight: 900;
			cursor: pointer;
		}
		.head-snav-li .select{
			color: #88AF51;
		}
		/* ============================ */
		.h-tab-box{
			padding: 30px 10%;
		}
		.h-tab-ul{
			border-bottom: .1rem solid #272727;
			display: flex;
			justify-content: start;
			align-items: center;
		}
		.h-tab-li{
			width: 32%;
		}
		.h-tab-cell{
			width: 40%;
			margin: 0 auto;
			padding-bottom: .5rem;
			cursor: pointer;
			position: relative;
		}
		.h-tab-line{
			width: 100%;
			height: .3rem;
			background-color: #a0cc5e;
			border-radius: .2rem;
			opacity: 0;
			position: absolute;
			bottom: -.1rem;
			left: 0;
		}
		.h-tab-cell.select .h-tab-line{
			opacity: 1;
		}
		/* =================== */
		.h-snav-box{
			margin-top: 1.5rem;
			display: flex;
			margin-left: 9%;
		}
		.h-snav-ul{
			margin-right: 1.5rem;
		}
		.h-snav-cell{
			padding-top: .5vw;
			font-size: .89vw;
			display: flex;
			justify-content: flex-start;
			align-items: center;
			font-weight: bold;
			color: black;
			cursor: pointer;
		}
		.h-snav-pont{
			margin-right: .4rem;
			font-size: 1.5vw;
		}
		.h-snav-cell.select{
			color: #a0cc5e;
		}
		.h-snav-box.energyText{
			justify-content: flex-start;
			margin-left: 41%;
		}
		.h-snav-box.lightText{
			justify-content:flex-end;
		}
		.lightText .h-snav-ul{
			width: 25%;
		}
	}
	.h-tab-box{
		background-color: rgba(16, 22, 27, .6);
	}
	.h-snav-cell{
		color: #fff;
	}
</style>
